import { render, staticRenderFns } from "./SlugField.vue?vue&type=template&id=72fa10bd&scoped=true&"
import script from "./SlugField.vue?vue&type=script&lang=ts&"
export * from "./SlugField.vue?vue&type=script&lang=ts&"
import style0 from "./SlugField.vue?vue&type=style&index=0&id=72fa10bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa10bd",
  null
  
)

export default component.exports